<template>
  <NumeraiTooltip text="Daily change">
    <div class="delta_container">
      <v-icon v-if="value > 0" :small="small" color="#04aa33"
        >mdi-menu-up</v-icon
      >
      <v-icon v-else-if="value < 0" :small="small" color="#d20000"
        >mdi-menu-down</v-icon
      >
      <v-icon v-else :x-small="small" class="no-movement">mdi-minus</v-icon>
      <span v-if="Math.abs(value) > 0" :style="{ color: textColorStyle }">
        {{ Math.abs(value) }}
      </span>
    </div>
  </NumeraiTooltip>
</template>

<script>
import NumeraiTooltip from '@/components/shared/NumeraiTooltip'

export default {
  components: {
    NumeraiTooltip,
  },
  props: {
    value: { type: [String, Number], default: null },
    colorText: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
  },
  computed: {
    textColorStyle() {
      if (!this.colorText) {
        return ''
      }

      if (this.value > 0) {
        return '#04aa33'
      } else if (this.value < 0) {
        return '#d20000'
      } else {
        return ''
      }
    },
  },
}
</script>
<style scoped>
.delta_container {
  font-family: var(--number-font);
}

.no-movement {
  color: var(--color-subtle);
}
</style>
